import { render, staticRenderFns } from "./add.vue?vue&type=template&id=109d8d2b&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=109d8d2b&scoped=true&lang=scss&"
import style1 from "./add.vue?vue&type=style&index=1&id=109d8d2b&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109d8d2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('109d8d2b')) {
      api.createRecord('109d8d2b', component.options)
    } else {
      api.reload('109d8d2b', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=109d8d2b&scoped=true&", function () {
      api.rerender('109d8d2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/freight/add.vue"
export default component.exports